export enum ActionButtons {
	approvalIcon = 'file-2_approval-seal_bb',
	visibilityIcon = 'visibility-on_b',
	trashIcon = 'trash_b',
	editIcon = 'edit-line_b',
	circlePause = 'circle-pause_b',
	circlePlay = 'circle-play_b',
	envelopeSend = 'envelope_send_bb',
}
